export const LoyaltyLevel = {
  EeInvestor: "LoyaltyProgram.EeInvestor",
  LtInvestor: "LoyaltyProgram.LtInvestor",
  LvInvestor: "LoyaltyProgram.LvInvestor",
};

export const investorLoyaltyLevels = [
  LoyaltyLevel.EeInvestor,
  LoyaltyLevel.LtInvestor,
  LoyaltyLevel.LvInvestor,
] as const;

export const isInvestorLoyaltyLevel = (externalIdentifier: string) =>
  investorLoyaltyLevels.includes(externalIdentifier);

export type ILoyaltyProgram = {
  id: number;
  name: string;
  levelName: string;
  externalIdentifier: string;
};
